/**
 * @file ms-excel.icon.tsx
 * @description Компонент для отображения иконки excel.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [classnames]
 */

import cn from 'classnames';
import { IIconProps } from '@src/types';

export const MSExcelIcon = ({ className, size = '1.6937vmin', color = '#33617D', onClick }: IIconProps) => {
    return (
        <div className={cn(className, { 'cursor-pointer': onClick })} onClick={onClick} style={{ color }}>
            <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.114 2.16602C14.2607 2.16602 14.3918 2.22157 14.5073 2.33268C14.614 2.43935 14.6673 2.56824 14.6673 2.71935V13.2793C14.6673 13.4305 14.614 13.5593 14.5073 13.666C14.3918 13.7771 14.2607 13.8327 14.114 13.8327H5.22065C5.07398 13.8327 4.94287 13.7771 4.82732 13.666C4.72065 13.5593 4.66732 13.4305 4.66732 13.2793V11.3327H1.88732C1.74065 11.3327 1.60954 11.2793 1.49398 11.1727C1.38732 11.0571 1.33398 10.926 1.33398 10.7793V5.21935C1.33398 5.07268 1.38732 4.94157 1.49398 4.82602C1.60954 4.71935 1.74065 4.66602 1.88732 4.66602H4.66732V2.71935C4.66732 2.56824 4.72065 2.43935 4.82732 2.33268C4.94287 2.22157 5.07398 2.16602 5.22065 2.16602M4.66732 8.70602L5.45398 10.186H6.64732L5.33398 8.03935L6.62065 5.92602H5.48065L4.75398 7.26602L4.72732 7.30602L4.70732 7.35268C4.59176 7.11713 4.46732 6.87935 4.33398 6.63935C4.22287 6.40379 4.1051 6.16602 3.98065 5.92602H2.77398L4.03398 8.05268L2.66732 10.186H3.85398M9.25398 12.9993V11.3327H5.50065V12.9993M9.25398 10.4993V8.41935H8.00065V10.4993M9.25398 7.58602V5.49935H8.00065V7.58602M9.25398 4.66602V2.99935H5.50065V4.66602M13.834 12.9993V11.3327H10.0873V12.9993M13.834 10.4993V8.41935H10.0873V10.4993M13.834 7.58602V5.49935H10.0873V7.58602M13.834 4.66602V2.99935H10.0873V4.66602H13.834Z"
                    fill="currentcolor"
                />
            </svg>
        </div>
    );
};
